/**
 * The messages badge in the header — the `header.actions` slot, and the only
 * way to `/messages`: the page has no menu entry.
 *
 * Polls the unread count through core's `usePolledValue`, as the notification
 * bell does. It also listens for the count a state change answers with, so
 * opening a message clears it at once rather than up to a minute later.
 *
 * A button to the page rather than a popover: a message is something you open
 * and read, and the page is where that happens.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import { BadgeIconButton } from '../../components/BadgeIconButton';
import { usePolledValue } from '../../hooks/usePolledValue';
import { onUnreadChanged, unreadMessageCount } from './api';

export function MessagesButton() {
  const { t } = useTranslation('messaging');
  const navigate = useNavigate();
  const [count, setCount] = usePolledValue(async () => (await unreadMessageCount()).unreadCount, 0);

  useEffect(() => onUnreadChanged(setCount), [setCount]);

  return (
    <BadgeIconButton
      label={t('header.tooltip')}
      icon={<MailOutlinedIcon />}
      count={count}
      onClick={() => navigate('/messages')}
    />
  );
}
